import { API2_HOST} from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch,
  baseGet
} from 'services/base-services/baseService';
import { getAllEvaUsers } from 'services/userServices';

const baseURL = `${API2_HOST}/sm-training-records`;
import axios from "services/api";;
import { objectToQueryString } from 'helpers/utils';
axios.defaults.withCredentials = true;


const search = async request => {
  return await baseSearch(baseURL, request);
};

const getNotCompletes = async request => {
  return await baseSearch(baseURL + '/get-incomplete-records', request);
};

const getNotCompleteUsers = async request => {
  return await baseSearch(baseURL + '/get-incomplete-users', request);
};

const searchUsers = async request => {
  let res = await getAllEvaUsers();
  if (request.ids) {
    res = res.filter(i => request.ids.map(x => x.trainee).includes(i.userId));
  }

  const rs = {
    items: res,
    total: res.length
  };
  return rs;
};

const post = async request => {
  return await basePost(baseURL, request);
};

const get = async id => {
  return await baseGet(baseURL, id);
};

const getByParam = async param => {
  const paramStr = `by-param?${objectToQueryString(param)}`;
  return await baseGet(baseURL, paramStr);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

export {
  search,
  post,
  patch,
  get,
  getByParam,
  searchUsers,
  getNotCompletes,
  getNotCompleteUsers
};
